/**
 * Viewer-side entry point of the build mode. The flag itself lives in
 * @ohif/core (core/src/utils/buildMode.js), the single reader of
 * `process.env.OFFLINE_MODE`, so that core and ui code can branch on it too.
 */
export { IS_OFFLINE_BUILD } from '@ohif/core/src/utils/buildMode';
